import { useWatch } from "react-hook-form";

import {
  PlatformEventType,
  TriggerSourceType,
  type TriggerTemplateCatalog,
} from "@/shared/domain/triggers";
import { useTriggerTemplateCatalog } from "@/shared/domain/triggers/hooks";

import { type TriggerFormValues } from "./triggerFormSchema";

/**
 * The `{{ }}` vocabulary the form currently offers: the paths shared by the
 * checked changes, or the schedule occurrence's own when the trigger fires on
 * a clock.
 *
 * Three parts of the form need it — the variables aside, the condition
 * builder, and the placeholder pickers — and they share one samples query, so
 * only the choice of events is worth holding in one place.
 */
export function useFormTemplateCatalog(): TriggerTemplateCatalog {
  const firesOn = useWatch<TriggerFormValues, "firesOn">({ name: "firesOn" });
  return useTriggerTemplateCatalog(
    firesOn.type === TriggerSourceType.Schedule
      ? [PlatformEventType.ScheduleFired]
      : firesOn.events,
  );
}
